import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
/* import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath'; */
import { useLogout } from 'app/core/api/auth/api-auth';
/* import { appEnv } from 'app/core/environment'; */
import { contextActions } from 'app/core/redux/context-redux';
import styledConsts from 'app/styles/styledConsts';
import styledFuncs from 'app/styles/styledFuncs';
import { deleteStoredItem } from 'app/tools/hooks/local-storage/local-storage-methods';
import { LSKey } from 'app/tools/hooks/local-storage/local-storage.types';
import useSafeAreaInsets from 'app/tools/hooks/use-safe-area-insets';
import { ReactComponent as LogoBanner } from 'assets/logo-banner.svg';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import Button from '../components/button/Button';
import Icon from '../components/icon/Icon';
import IconLib from '../components/icon/icon-lib';
import { PadExpand } from '../components/misc';
import SharedRoutePath from '../SharedRoutePath';

const BannerBox = styled.div`
  padding: ${styledFuncs.pad(4)} ${styledFuncs.pad(3)}
    ${styledFuncs.pad(3)} ${styledFuncs.pad(2)};
`;

const TextButton = styled(Button)`
  width: 70px;
  height: 70px;
  padding: ${styledFuncs.pad(0.5)};

  .MuiIconButton-label {
    height: 55px;
    flex-direction: column;
    justify-content: space-between;
    font-size: ${styledFuncs.pxToRem(12)};
    color: ${styledConsts.cText};
    margin-bottom: -5px;
  }
`;

const ListBox = styled(List)<{ component: 'nav' }>`
  padding-left: ${styledFuncs.pad()};
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;

  .MuiListItem-root {
    margin-bottom: ${styledFuncs.pad(2)};
  }

  > div:last-child {
    display: flex;
    padding: ${styledFuncs.pad()};
    padding-left: 0;
    justify-content: space-between;
  }
`;

export default function SideMenu(): JSX.Element {
  const showNavItems = useSelector(s => s.context.sideMenuNavItems);
  const navItemsInput = useSelector(s => s.context.navActions);
  const navItems = showNavItems ? navItemsInput : [];
  const history = useHistory();
  const dispatch = useDispatch();

  const { request$: logout$, sending: loggingOut } = useLogout();
  const makeLogOut = () => {
    deleteStoredItem(LSKey.BUSINESS_PROFILE_TEMP);
    logout$().subscribe();
  };
  const closeMenu = useCallback(() => {
    dispatch(contextActions.menuOpen.set(false));
  }, [dispatch]);

  const MenuItem: React.VFC<{
    icon: IconLib;
    label: string;
    path: string;
  }> = useCallback(
    ({ icon, label, path }) => (
      <ListItem
        button
        onClick={() => {
          closeMenu();
          history.push(path);
        }}
      >
        <ListItemIcon>
          <Icon {...{ icon }} color="textPrimary" />
        </ListItemIcon>
        <ListItemText primary={label} />
      </ListItem>
    ),
    [closeMenu, history]
  );

  const { top: topMargin, bottom: bottomMargin } =
    useSafeAreaInsets();

  return (
    <>
      <BannerBox
        css={css`
          padding-top: ${p =>
            Math.max(
              p.theme.spacing(4),
              p.theme.spacing(1) + topMargin
            )}px;
        `}
      >
        <LogoBanner
          onClick={() => {
            closeMenu();
            history.push(SharedRoutePath.HOME);
          }}
        />
      </BannerBox>
      <ListBox component="nav" aria-label="side menu">
        {navItems?.map(({ icon, label, value }) => (
          <MenuItem
            key={value + label}
            path={value}
            {...{ icon, label }}
          />
        ))}
        <PadExpand />
        {/* appEnv.APP_VARIANT === 'consumer' && (
          <MenuItem
            path={ConsumerRoutePath.PROFILE}
            icon={IconLib.SETTINGS}
            label="Profile"
          />
        ) */}
        <div>
          <TextButton
            iconButton
            disabled={loggingOut}
            onClick={() => {
              closeMenu();
              makeLogOut();
            }}
          >
            <Icon icon={IconLib.EXIT} color="textPrimary" size={28} />
            Logout
          </TextButton>
          <TextButton iconButton onClick={() => closeMenu()}>
            <Icon
              icon={IconLib.CROSS_BOXED}
              color="textPrimary"
              size={28}
            />
            Close
          </TextButton>
        </div>
      </ListBox>
      <div
        css={css`
          width: 100%;
          margin-bottom: ${bottomMargin / 4}px;
        `}
      />
    </>
  );
}
